import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "size"],
  _excluded2 = ["children", "size"],
  _excluded3 = ["children", "size"],
  _excluded4 = ["children", "size"],
  _excluded5 = ["children", "size"],
  _excluded6 = ["children", "size"],
  _excluded7 = ["children", "size"],
  _excluded8 = ["children", "size"],
  _excluded9 = ["children", "size"],
  _excluded0 = ["children", "size"],
  _excluded1 = ["children", "size"],
  _excluded10 = ["children", "size"],
  _excluded11 = ["children", "size"],
  _excluded12 = ["children", "size"],
  _excluded13 = ["children", "size"],
  _excluded14 = ["children", "size"],
  _excluded15 = ["children", "size"],
  _excluded16 = ["children", "size"],
  _excluded17 = ["children", "size"],
  _excluded18 = ["children", "size"],
  _excluded19 = ["children", "size"],
  _excluded20 = ["children", "size"],
  _excluded21 = ["children", "size"],
  _excluded22 = ["children", "size"],
  _excluded23 = ["children", "size"],
  _excluded24 = ["children", "size"],
  _excluded25 = ["children", "size"],
  _excluded26 = ["children", "size"],
  _excluded27 = ["children", "size"],
  _excluded28 = ["children", "size"],
  _excluded29 = ["children", "size"],
  _excluded30 = ["children", "size"],
  _excluded31 = ["children", "size"],
  _excluded32 = ["children", "size"],
  _excluded33 = ["children", "size"],
  _excluded34 = ["children", "size"],
  _excluded35 = ["children", "size"],
  _excluded36 = ["children", "size"],
  _excluded37 = ["children", "size"],
  _excluded38 = ["children", "size"],
  _excluded39 = ["children", "size"],
  _excluded40 = ["children", "size"],
  _excluded41 = ["children", "size"],
  _excluded42 = ["children", "size"],
  _excluded43 = ["children", "size"],
  _excluded44 = ["children", "size"],
  _excluded45 = ["children", "size"],
  _excluded46 = ["children", "size"],
  _excluded47 = ["children", "size"],
  _excluded48 = ["children", "size"],
  _excluded49 = ["children", "size"],
  _excluded50 = ["children", "size"],
  _excluded51 = ["children", "size"],
  _excluded52 = ["children", "size"],
  _excluded53 = ["children", "size"],
  _excluded54 = ["children", "size"],
  _excluded55 = ["children", "size"],
  _excluded56 = ["children", "size"],
  _excluded57 = ["children", "size"],
  _excluded58 = ["children", "size"],
  _excluded59 = ["children", "size"],
  _excluded60 = ["children", "size"],
  _excluded61 = ["children", "size"],
  _excluded62 = ["children", "size"],
  _excluded63 = ["children", "size"],
  _excluded64 = ["children", "size"],
  _excluded65 = ["children", "size"],
  _excluded66 = ["children", "size"],
  _excluded67 = ["children", "size"],
  _excluded68 = ["children", "size"],
  _excluded69 = ["children", "size"],
  _excluded70 = ["children", "size"],
  _excluded71 = ["children", "size"],
  _excluded72 = ["children", "size"],
  _excluded73 = ["children", "size"],
  _excluded74 = ["children", "size"],
  _excluded75 = ["children", "size"],
  _excluded76 = ["children", "size"],
  _excluded77 = ["children", "size"],
  _excluded78 = ["children", "size"],
  _excluded79 = ["children", "size"],
  _excluded80 = ["children", "size"],
  _excluded81 = ["children", "size"],
  _excluded82 = ["children", "size"],
  _excluded83 = ["children", "size"],
  _excluded84 = ["children", "size"],
  _excluded85 = ["children", "size"],
  _excluded86 = ["children", "size"],
  _excluded87 = ["children", "size"],
  _excluded88 = ["children", "size"],
  _excluded89 = ["children", "size"],
  _excluded90 = ["children", "size"],
  _excluded91 = ["children", "size"],
  _excluded92 = ["children", "size"],
  _excluded93 = ["children", "size"],
  _excluded94 = ["children", "size"],
  _excluded95 = ["children", "size"],
  _excluded96 = ["children", "size"],
  _excluded97 = ["children", "size"],
  _excluded98 = ["children", "size"],
  _excluded99 = ["children", "size"],
  _excluded100 = ["children", "size"],
  _excluded101 = ["children", "size"],
  _excluded102 = ["children", "size"],
  _excluded103 = ["children", "size"],
  _excluded104 = ["children", "size"],
  _excluded105 = ["children", "size"],
  _excluded106 = ["children", "size"],
  _excluded107 = ["children", "size"],
  _excluded108 = ["children", "size"],
  _excluded109 = ["children", "size"],
  _excluded110 = ["children", "size"],
  _excluded111 = ["children", "size"],
  _excluded112 = ["children", "size"],
  _excluded113 = ["children", "size"],
  _excluded114 = ["children", "size"],
  _excluded115 = ["children", "size"],
  _excluded116 = ["children", "size"],
  _excluded117 = ["children", "size"],
  _excluded118 = ["children", "size"],
  _excluded119 = ["children", "size"],
  _excluded120 = ["children", "size"],
  _excluded121 = ["children", "size"],
  _excluded122 = ["children", "size"],
  _excluded123 = ["children", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import React from 'react';
import Icon from '../Icon.js';
import { i as iconPropTypes } from '../iconPropTypes-C5chbmyn.js';
import '@carbon/icon-helpers';
var _path, _path2, _path3, _path4, _path5, _path6, _switch, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _circle, _circle2, _circle3, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _circle4, _path112, _circle5, _path113, _path114, _circle6, _path115, _path116, _path117, _path118, _path119, _circle7, _circle8, _circle9, _circle0, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _circle1, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _circle10, _circle11, _path147, _circle12, _circle13, _path148, _path149, _circle14, _circle15, _path150, _path151, _circle16, _circle17, _path152, _path153, _circle18, _circle19, _path154, _path155, _circle20, _circle21, _path156, _path157, _circle22, _circle23, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _rect, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198;
var Rss = /*#__PURE__*/React.forwardRef(function Rss(_ref, ref) {
  var children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6C14 20.7 11.3 18 8 18zM8 28c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4C12 26.2 10.2 28 8 28zM30 24h-2C28 13 19 4 8 4V2C20.1 2 30 11.9 30 24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Rule = /*#__PURE__*/React.forwardRef(function Rule(_ref2, ref) {
  var children = _ref2.children,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 16 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H22V18H10zM10 10H22V12H10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var RuleCancelled = /*#__PURE__*/React.forwardRef(function RuleCancelled(_ref3, ref) {
  var children = _ref3.children,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 16 : _ref3$size,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24a6 6 0 10-6 6A6.0066 6.0066 0 0030 24zm-2 0a3.9521 3.9521 0 01-.5669 2.019L21.981 20.5669A3.9529 3.9529 0 0124 20 4.0045 4.0045 0 0128 24zm-8 0a3.9521 3.9521 0 01.5669-2.019l5.4521 5.4521A3.9529 3.9529 0 0124 28 4.0045 4.0045 0 0120 24zM8 16H18V18H8zM8 10H20V12H8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var RuleDataQuality = /*#__PURE__*/React.forwardRef(function RuleDataQuality(_ref4, ref) {
  var children = _ref4.children,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 16 : _ref4$size,
    rest = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 28.6l-2.8-2.8C27.7 25 28 24 28 23c0-2.8-2.2-5-5-5s-5 2.2-5 5 2.2 5 5 5c1 0 2-.3 2.8-.8l2.8 2.8L30 28.6zM20 23c0-1.7 1.3-3 3-3s3 1.3 3 3-1.3 3-3 3S20 24.7 20 23zM8 16H18V18H8zM8 10H20V12H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z"
  })))), children);
});
if (process.env.NODE_ENV !== "production") {}
var RuleDraft = /*#__PURE__*/React.forwardRef(function RuleDraft(_ref5, ref) {
  var children = _ref5.children,
    _ref5$size = _ref5.size,
    size = _ref5$size === void 0 ? 16 : _ref5$size,
    rest = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707 19.293l-3-3a.9994.9994 0 00-1.414 0L16 25.5859V30h4.4141l9.2929-9.293A.9994.9994 0 0029.707 19.293zM19.5859 28H18V26.4141l5-5L24.5859 23zM26 21.5859L24.4141 20 26 18.4141 27.5859 20zM8 16H18V18H8zM8 10H20V12H8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var RuleFilled = /*#__PURE__*/React.forwardRef(function RuleFilled(_ref6, ref) {
  var children = _ref6.children,
    _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? 16 : _ref6$size,
    rest = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9 16H23V18H9z",
    "data-icon-path": "inner-path"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9 10H23V12H9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var RuleLocked = /*#__PURE__*/React.forwardRef(function RuleLocked(_ref7, ref) {
  var children = _ref7.children,
    _ref7$size = _ref7.size,
    size = _ref7$size === void 0 ? 16 : _ref7$size,
    rest = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22v-3c0-2.2-1.8-4-4-4s-4 1.8-4 4v3c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-5C30 22.9 29.1 22 28 22zM22 19c0-1.1.9-2 2-2s2 .9 2 2v3h-4V19zM20 29v-5h8v5H20zM8 16H14V18H8zM8 10H20V12H8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7l5.2,2.8v-2.3l-4.2-2.3C5.8,23.4,4,20.3,4,17V4h20v8h2V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var RulePartial = /*#__PURE__*/React.forwardRef(function RulePartial(_ref8, ref) {
  var children = _ref8.children,
    _ref8$size = _ref8.size,
    size = _ref8$size === void 0 ? 16 : _ref8$size,
    rest = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7S26.9 16 23 16zM23 28V18c2.8 0 5 2.2 5 5S25.8 28 23 28zM8 16H14V18H8zM8 10H20V12H8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7l5.2,2.8v-2.3l-4.2-2.3C5.8,23.4,4,20.3,4,17V4h20v9h2V4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var RuleTest = /*#__PURE__*/React.forwardRef(function RuleTest(_ref9, ref) {
  var children = _ref9.children,
    _ref9$size = _ref9.size,
    size = _ref9$size === void 0 ? 16 : _ref9$size,
    rest = _objectWithoutProperties(_ref9, _excluded9);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24.586L24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586zM8 16H14V18H8zM8 10H20V12H8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Ruler = /*#__PURE__*/React.forwardRef(function Ruler(_ref0, ref) {
  var children = _ref0.children,
    _ref0$size = _ref0.size,
    size = _ref0$size === void 0 ? 16 : _ref0$size,
    rest = _objectWithoutProperties(_ref0, _excluded0);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var RulerAlt = /*#__PURE__*/React.forwardRef(function RulerAlt(_ref1, ref) {
  var children = _ref1.children,
    _ref1$size = _ref1.size,
    size = _ref1$size === void 0 ? 16 : _ref1$size,
    rest = _objectWithoutProperties(_ref1, _excluded1);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Run = /*#__PURE__*/React.forwardRef(function Run(_ref10, ref) {
  var children = _ref10.children,
    _ref10$size = _ref10.size,
    size = _ref10$size === void 0 ? 16 : _ref10$size,
    rest = _objectWithoutProperties(_ref10, _excluded10);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19L19 25 24 22 19 19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var RunMirror = /*#__PURE__*/React.forwardRef(function RunMirror(_ref11, ref) {
  var children = _ref11.children,
    _ref11$size = _ref11.size,
    size = _ref11$size === void 0 ? 16 : _ref11$size,
    rest = _objectWithoutProperties(_ref11, _excluded11);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19L9 25 14 22z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14 L11,14z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Running = /*#__PURE__*/React.forwardRef(function Running(_ref12, ref) {
  var children = _ref12.children,
    _ref12$size = _ref12.size,
    size = _ref12$size === void 0 ? 16 : _ref12$size,
    rest = _objectWithoutProperties(_ref12, _excluded12);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m21.707,20.293l-5-5c-.1951-.1953-.451-.293-.707-.293s-.512.0977-.707.293L2,28.5859l1.4143,1.4141,12.5857-12.5859,3.5857,3.5859-5.5857,5.5859,1.4143,1.4141,2.292-2.292,4.0007-4.001c.1953-.1953.293-.4512.293-.707s-.0977-.5117-.293-.707Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m28.5859,9l-5.5859,5.5859-6.0012-6.0015c-.392-.3918-.9073-.5865-1.422-.5845-.5096.002-1.0185.1968-1.4063.5845l-6.1704,6.1753,1.4143,1.4141,6.1704-6.1748,6.7083,6.708c.1951.1953.4512.293.707.293s.512-.0977.707-.293l6.293-6.293-1.4141-1.4141Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5,9c-1.9299,0-3.5-1.5701-3.5-3.5s1.5701-3.5,3.5-3.5,3.5,1.5701,3.5,3.5-1.5701,3.5-3.5,3.5Zm0-5c-.8271,0-1.5.6729-1.5,1.5s.6729,1.5,1.5,1.5,1.5-.6729,1.5-1.5-.6729-1.5-1.5-1.5Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QS = /*#__PURE__*/React.forwardRef(function QS(_ref13, ref) {
  var children = _ref13.children,
    _ref13$size = _ref13.size,
    size = _ref13$size === void 0 ? 16 : _ref13$size,
    rest = _objectWithoutProperties(_ref13, _excluded13);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var QSAlt = /*#__PURE__*/React.forwardRef(function QSAlt(_ref14, ref) {
  var children = _ref14.children,
    _ref14$size = _ref14.size,
    size = _ref14$size === void 0 ? 16 : _ref14$size,
    rest = _objectWithoutProperties(_ref14, _excluded14);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9L22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9zM14 23H8V21h6V17H10a2 2 0 01-2-2V11a2 2 0 012-2h6v2H10v4h4a2 2 0 012 2v4A2 2 0 0114 23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SailboatCoastal = /*#__PURE__*/React.forwardRef(function SailboatCoastal(_ref15, ref) {
  var children = _ref15.children,
    _ref15$size = _ref15.size,
    size = _ref15$size === void 0 ? 16 : _ref15$size,
    rest = _objectWithoutProperties(_ref15, _excluded15);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SailboatOffshore = /*#__PURE__*/React.forwardRef(function SailboatOffshore(_ref16, ref) {
  var children = _ref16.children,
    _ref16$size = _ref16.size,
    size = _ref16$size === void 0 ? 16 : _ref16$size,
    rest = _objectWithoutProperties(_ref16, _excluded16);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SalesOps = /*#__PURE__*/React.forwardRef(function SalesOps(_ref17, ref) {
  var children = _ref17.children,
    _ref17$size = _ref17.size,
    size = _ref17$size === void 0 ? 16 : _ref17$size,
    rest = _objectWithoutProperties(_ref17, _excluded17);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6v-2h-3v-2h-2v2h-1c-1.1028 0-2 .8975-2 2v2c0 1.1025.8972 2 2 2h4v2h-6v2h3v2h2v-2h1c1.1028 0 2-.8975 2-2v-2c0-1.1025-.8972-2-2-2h-4v-2h6zM24 20v2h2.5859l-3.5857 3.5859-2.2917-2.293c-.1875-.1875-.4419-.293-.707-.293h-.0015c-.2651 0-.5183.1055-.7058.293l-5.2942 5.293 1.4143 1.4141 4.5867-4.5859 2.2917 2.293c.1875.1875.4419.293.7073.293.2651 0 .5195-.1055.707-.293l4.293-4.293v2.5859h2v-6h-6zM4 30h-2v-5c0-3.8599 3.1401-7 7-7h6c1.9885 0 3.8901.8502 5.217 2.3328l-1.4902 1.334c-.948-1.0592-2.3064-1.6667-3.7268-1.6667h-6c-2.7571 0-5 2.243-5 5v5zM12 16c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm0-12c2.7615 0 5 2.2385 5 5s-2.2385 5-5 5-5-2.2385-5-5c.0032-2.7601 2.2399-4.9968 5-5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SankeyDiagram = /*#__PURE__*/React.forwardRef(function SankeyDiagram(_ref18, ref) {
  var children = _ref18.children,
    _ref18$size = _ref18.size,
    size = _ref18$size === void 0 ? 16 : _ref18$size,
    rest = _objectWithoutProperties(_ref18, _excluded18);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SankeyDiagramAlt = /*#__PURE__*/React.forwardRef(function SankeyDiagramAlt(_ref19, ref) {
  var children = _ref19.children,
    _ref19$size = _ref19.size,
    size = _ref19$size === void 0 ? 16 : _ref19$size,
    rest = _objectWithoutProperties(_ref19, _excluded19);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Sap = /*#__PURE__*/React.forwardRef(function Sap(_ref20, ref) {
  var children = _ref20.children,
    _ref20$size = _ref20.size,
    size = _ref20$size === void 0 ? 16 : _ref20$size,
    rest = _objectWithoutProperties(_ref20, _excluded20);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M29,8h-6.1843c-.4141-1.1611-1.5137-2-2.8157-2s-2.4016.8389-2.8157,2H4c-1.1046,0-2,.8954-2,2v12c0,1.1046.8954,2,2,2h1.1843c.4141,1.1611,1.5137,2,2.8157,2s2.4016-.8389,2.8157-2h4.1843c.2653,0,.5197-.1054.7073-.293l14-14c.6299-.6299.1836-1.707-.7073-1.707ZM20,8c.5522,0,1,.4478,1,1s-.4478,1-1,1-1-.4478-1-1,.4478-1,1-1ZM8,24c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1ZM14.5857,22h-3.77c-.4141-1.1611-1.5137-2-2.8157-2s-2.4016.8389-2.8157,2h-1.1843v-12h13.1843c.4141,1.1611,1.5137,2,2.8157,2s2.4016-.8389,2.8157-2h3.77s-12,12-12,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Satellite = /*#__PURE__*/React.forwardRef(function Satellite(_ref21, ref) {
  var children = _ref21.children,
    _ref21$size = _ref21.size,
    size = _ref21$size === void 0 ? 16 : _ref21$size,
    rest = _objectWithoutProperties(_ref21, _excluded21);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SatelliteRadar = /*#__PURE__*/React.forwardRef(function SatelliteRadar(_ref22, ref) {
  var children = _ref22.children,
    _ref22$size = _ref22.size,
    size = _ref22$size === void 0 ? 16 : _ref22$size,
    rest = _objectWithoutProperties(_ref22, _excluded22);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M26 14H24a6.0067 6.0067 0 00-6-6V6A8.0092 8.0092 0 0126 14zM16 28V24.96a9.9124 9.9124 0 007.3179-2.208 1.8482 1.8482 0 00.6777-1.3344 1.8 1.8 0 00-.5239-1.36L18.4141 15 21 12.4141 19.5859 11 17 13.5859 11.9419 8.5273a1.8145 1.8145 0 00-1.36-.5229 1.845 1.845 0 00-1.3339.6782 9.9566 9.9566 0 00-.5127 11.95L6.2793 28H2v2H30V28zM10.68 10.0938L21.9058 21.32A8.0011 8.0011 0 0110.68 10.0938zM14 28H8.3875l1.8757-5.627A9.9894 9.9894 0 0014 24.5435z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SatelliteWeather = /*#__PURE__*/React.forwardRef(function SatelliteWeather(_ref23, ref) {
  var children = _ref23.children,
    _ref23$size = _ref23.size,
    size = _ref23$size === void 0 ? 16 : _ref23$size,
    rest = _objectWithoutProperties(_ref23, _excluded23);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12H19a4 4 0 010-8h.0835A4.7864 4.7864 0 0123 2a4.9816 4.9816 0 014.6543 3.2034A3.4667 3.4667 0 0130 8.5 3.5041 3.5041 0 0126.5 12zM19 6a2 2 0 000 4h7.5A1.5017 1.5017 0 0028 8.5a1.4855 1.4855 0 00-1.2778-1.4739L26.061 6.927l-.1616-.6487a2.9568 2.9568 0 00-5.4873-.7121L20.1143 6zM13 28V24.8882a7.9363 7.9363 0 004.707-2.2818.9995.9995 0 000-1.414L13.4644 16.95 16 14.4141 14.5859 13 12.05 15.5356 7.8076 11.293a.9994.9994 0 00-1.414 0 7.9993 7.9993 0 000 11.3134c.1621.1622.3327.3125.5058.459L4.4321 28H2v2H30V28zm-2 0H6.6685L8.59 24.1567A7.8927 7.8927 0 0011 24.873zM7.8076 21.1924a6.0036 6.0036 0 01-.6489-7.72l8.3686 8.3681a6.0026 6.0026 0 01-7.72-.6484z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SatisfyDefinition = /*#__PURE__*/React.forwardRef(function SatisfyDefinition(_ref24, ref) {
  var children = _ref24.children,
    _ref24$size = _ref24.size,
    size = _ref24$size === void 0 ? 16 : _ref24$size,
    rest = _objectWithoutProperties(_ref24, _excluded24);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M17.3945 19.5537c0-1.8433 1.3953-2.7563 3.8416-2.7563h1.5332v-.6545c0-.9993-.4995-1.585-1.6709-1.585-1.0337 0-1.6194.5168-2.05 1.137l-1.3093-1.1714c.6545-1.0337 1.7056-1.7228 3.5144-1.7228 2.429 0 3.7209 1.1543 3.7209 3.2042v4.2379h.896v1.7572h-1.2231c-.9475 0-1.5332-.6201-1.6711-1.5504h-.1033c-.293 1.1542-1.2749 1.7572-2.6187 1.7572-1.8259 0-2.8596-1.0509-2.8596-2.6531zm5.3624-.2412v-1.1886h-1.4126c-1.1541 0-1.7227.3962-1.7227 1.1025v.2928c0 .7235.4995 1.0853 1.3608 1.0853.9819 0 1.7744-.4479 1.7744-1.2921zM6.6195 20.2084l1.5332-1.4816c.8269.9647 1.8433 1.4816 3.0837 1.4816 1.3953 0 2.1189-.6719 2.1189-1.6882 0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971 0-2.1534 1.6709-3.5488 4.3584-3.5488 1.8088 0 3.1526.6202 4.1172 1.7744l-1.5503 1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292 0-1.9639.5168-1.9639 1.4126 0 .9131.5168 1.292 1.6711 1.4988l1.1196.2067c2.429.4308 3.5662 1.516 3.5662 3.4972 0 2.2739-1.6367 3.8245-4.5137 3.8245-2.05 0-3.4626-.8097-4.479-1.9984z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SatisfyUsage = /*#__PURE__*/React.forwardRef(function SatisfyUsage(_ref25, ref) {
  var children = _ref25.children,
    _ref25$size = _ref25.size,
    size = _ref25$size === void 0 ? 16 : _ref25$size,
    rest = _objectWithoutProperties(_ref25, _excluded25);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M17.3934 19.5537c0-1.8433 1.3953-2.7563 3.8416-2.7563h1.5332v-.6545c0-.9993-.4995-1.585-1.6709-1.585-1.0337 0-1.6194.5168-2.05 1.137l-1.3093-1.1714c.6545-1.0337 1.7056-1.7228 3.5144-1.7228 2.429 0 3.7209 1.1543 3.7209 3.2042v4.2379h.896v1.7572h-1.2231c-.9475 0-1.5332-.6201-1.6711-1.5504h-.1033c-.293 1.1542-1.2749 1.7572-2.6187 1.7572-1.8259 0-2.8596-1.0509-2.8596-2.6531zm5.3624-.2412v-1.1886h-1.4126c-1.1541 0-1.7227.3962-1.7227 1.1025v.2928c0 .7235.4995 1.0853 1.3608 1.0853.9819 0 1.7744-.4479 1.7744-1.2921zM6.6184 20.2084l1.5332-1.4816c.8269.9647 1.8433 1.4816 3.0837 1.4816 1.3953 0 2.1189-.6719 2.1189-1.6882 0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971 0-2.1534 1.6709-3.5488 4.3584-3.5488 1.8088 0 3.1526.6202 4.1172 1.7744l-1.5503 1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292 0-1.9639.5168-1.9639 1.4126 0 .9131.5168 1.292 1.6711 1.4988l1.1196.2067c2.429.4308 3.5662 1.516 3.5662 3.4972 0 2.2739-1.6367 3.8245-4.5137 3.8245-2.05 0-3.4626-.8097-4.479-1.9984z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Save = /*#__PURE__*/React.forwardRef(function Save(_ref26, ref) {
  var children = _ref26.children,
    _ref26$size = _ref26.size,
    size = _ref26$size === void 0 ? 16 : _ref26$size,
    rest = _objectWithoutProperties(_ref26, _excluded26);
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
      d: "M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5 C14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1 h4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor"
    }, rest), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
      d: "M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1 C18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3 c0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4 L14,16.7L14,16.7z"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor"
    }, rest), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
      d: "M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12 C21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6 h-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthSaveAnnotation = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveAnnotation(_ref27, ref) {
  var children = _ref27.children,
    _ref27$size = _ref27.size,
    size = _ref27$size === void 0 ? 16 : _ref27$size,
    rest = _objectWithoutProperties(_ref27, _excluded27);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H26V8H20zM22 10H26V12H22z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthSaveImage = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveImage(_ref28, ref) {
  var children = _ref28.children,
    _ref28$size = _ref28.size,
    size = _ref28$size === void 0 ? 16 : _ref28$size,
    rest = _objectWithoutProperties(_ref28, _excluded28);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SaveModel = /*#__PURE__*/React.forwardRef(function SaveModel(_ref29, ref) {
  var children = _ref29.children,
    _ref29$size = _ref29.size,
    size = _ref29$size === void 0 ? 16 : _ref29$size,
    rest = _objectWithoutProperties(_ref29, _excluded29);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthSaveSeries = /*#__PURE__*/React.forwardRef(function WatsonHealthSaveSeries(_ref30, ref) {
  var children = _ref30.children,
    _ref30$size = _ref30.size,
    size = _ref30$size === void 0 ? 16 : _ref30$size,
    rest = _objectWithoutProperties(_ref30, _excluded30);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Scale = /*#__PURE__*/React.forwardRef(function Scale(_ref31, ref) {
  var children = _ref31.children,
    _ref31$size = _ref31.size,
    size = _ref31$size === void 0 ? 16 : _ref31$size,
    rest = _objectWithoutProperties(_ref31, _excluded31);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Scales = /*#__PURE__*/React.forwardRef(function Scales(_ref32, ref) {
  var children = _ref32.children,
    _ref32$size = _ref32.size,
    size = _ref32$size === void 0 ? 16 : _ref32$size,
    rest = _objectWithoutProperties(_ref32, _excluded32);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScalesTipped = /*#__PURE__*/React.forwardRef(function ScalesTipped(_ref33, ref) {
  var children = _ref33.children,
    _ref33$size = _ref33.size,
    size = _ref33$size === void 0 ? 16 : _ref33$size,
    rest = _objectWithoutProperties(_ref33, _excluded33);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Scalpel = /*#__PURE__*/React.forwardRef(function Scalpel(_ref34, ref) {
  var children = _ref34.children,
    _ref34$size = _ref34.size,
    size = _ref34$size === void 0 ? 16 : _ref34$size,
    rest = _objectWithoutProperties(_ref34, _excluded34);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthScalpelCursor = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelCursor(_ref35, ref) {
  var children = _ref35.children,
    _ref35$size = _ref35.size,
    size = _ref35$size === void 0 ? 16 : _ref35$size,
    rest = _objectWithoutProperties(_ref35, _excluded35);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM13 4L4 4 4 13 6 13 6 6 13 6 13 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthScalpelLasso = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelLasso(_ref36, ref) {
  var children = _ref36.children,
    _ref36$size = _ref36.size,
    size = _ref36$size === void 0 ? 16 : _ref36$size,
    rest = _objectWithoutProperties(_ref36, _excluded36);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 7.1338a4.0941 4.0941 0 00-5.6562 0L.3433 29.9619H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.79a3.9984 3.9984 0 000-5.6562zM12.2928 20.8406l2.086-2.0858 2.8293 2.8293L15.1224 23.67zM11.71 27.083a2.9824 2.9824 0 01-2.1215.8789H5.1714l5.7073-5.7072 2.83 2.83zM27.4141 11.376L18.6221 20.17l-2.8293-2.8292 8.7931-8.7928a2.0471 2.0471 0 012.8282 0 1.9993 1.9993 0 010 2.8281zM11 2H7a4.9843 4.9843 0 00-3.8633 8.1528A2.9586 2.9586 0 003 11a2.9945 2.9945 0 002 2.8154V14a2.0025 2.0025 0 01-2 2H2v2H3a4.0045 4.0045 0 004-4v-.1841A2.9959 2.9959 0 008.8157 12H11A5 5 0 0011 2zM6 12a1 1 0 111-1A1.0009 1.0009 0 016 12zm5-2H8.8157A2.974 2.974 0 004.394 8.4746 2.9908 2.9908 0 017 4h4a3 3 0 010 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var WatsonHealthScalpelSelect = /*#__PURE__*/React.forwardRef(function WatsonHealthScalpelSelect(_ref37, ref) {
  var children = _ref37.children,
    _ref37$size = _ref37.size,
    size = _ref37$size === void 0 ? 16 : _ref37$size,
    rest = _objectWithoutProperties(_ref37, _excluded37);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 7.1719a4.0941 4.0941 0 00-5.6562 0L.3433 30H9.5889a4.9682 4.9682 0 003.5356-1.4648L28.8281 12.8281a3.9984 3.9984 0 000-5.6562zM12.2928 20.8787l2.086-2.0859 2.8293 2.8294-2.0857 2.0862zM11.71 27.1211A2.9824 2.9824 0 019.5889 28H5.1714l5.7073-5.7072 2.83 2.83zm15.7037-15.707l-8.792 8.7939-2.8293-2.8292 8.7931-8.7929a2.0473 2.0473 0 012.8282 0 1.9995 1.9995 0 010 2.8282zM15 2a2.9948 2.9948 0 00-2.8157 2H7.8156A2.9925 2.9925 0 104 7.8154v4.3687a3 3 0 102 0V7.8159A2.9959 2.9959 0 007.8156 6h4.3686A2.9947 2.9947 0 1015 2zM5 16a1 1 0 111-1A1.0008 1.0008 0 015 16zM5 6A1 1 0 116 5 1.0008 1.0008 0 015 6zM15 6a1 1 0 111-1A1.0008 1.0008 0 0115 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Scan = /*#__PURE__*/React.forwardRef(function Scan(_ref38, ref) {
  var children = _ref38.children,
    _ref38$size = _ref38.size,
    size = _ref38$size === void 0 ? 16 : _ref38$size,
    rest = _objectWithoutProperties(_ref38, _excluded38);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H17V23H15zM27 9H29V23H27zM21 9H23V23H21z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScanAlt = /*#__PURE__*/React.forwardRef(function ScanAlt(_ref39, ref) {
  var children = _ref39.children,
    _ref39$size = _ref39.size,
    size = _ref39$size === void 0 ? 16 : _ref39$size,
    rest = _objectWithoutProperties(_ref39, _excluded39);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24H10a2 2 0 01-2-2V19h2v3H22V19h2v3A2 2 0 0122 24zM2 15H30V17H2zM24 13H22V10H10v3H8V10a2 2 0 012-2H22a2 2 0 012 2zM30 10L28 10 28 4 22 4 22 2 30 2 30 10zM4 10L2 10 2 2 10 2 10 4 4 4 4 10zM10 30L2 30 2 22 4 22 4 28 10 28 10 30zM30 30L22 30 22 28 28 28 28 22 30 22 30 30z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScanDisabled = /*#__PURE__*/React.forwardRef(function ScanDisabled(_ref40, ref) {
  var children = _ref40.children,
    _ref40$size = _ref40.size,
    size = _ref40$size === void 0 ? 16 : _ref40$size,
    rest = _objectWithoutProperties(_ref40, _excluded40);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3826 2.0762a.9993.9993 0 00-1.09.2168l-26 26A1 1 0 003 30h8V28H5.4143l4-4H22a2.0021 2.0021 0 002-2V9.4146l4-4V11h2V3A1 1 0 0029.3826 2.0762zM22 22H11.4143L22 11.4146zM10 17.7554V10h7.7554l2-2H10a2.0025 2.0025 0 00-2 2v9.7554zM11 2L2 2 2 11 4 11 4 4 11 4 11 2zM21 30L30 30 30 21 28 21 28 28 21 28 21 30zM4 23.755L4 21 2 21 2 25.754 4 23.755zM25.755 2L21 2 21 4 23.755 4 25.755 2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScatterMatrix = /*#__PURE__*/React.forwardRef(function ScatterMatrix(_ref41, ref) {
  var children = _ref41.children,
    _ref41$size = _ref41.size,
    size = _ref41$size === void 0 ? 16 : _ref41$size,
    rest = _objectWithoutProperties(_ref41, _excluded41);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "9.5",
    cy: "9.5",
    r: "2.5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.5",
    cy: "22.5",
    r: "2.5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.5",
    cy: "22.5",
    r: "2.5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4A2.0023,2.0023,0,0,0,2,4V28a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,13H17V4H28ZM15,4V15H4V4ZM4,17H15V28H4ZM17,28V17H28V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Schematics = /*#__PURE__*/React.forwardRef(function Schematics(_ref42, ref) {
  var children = _ref42.children,
    _ref42$size = _ref42.size,
    size = _ref42$size === void 0 ? 16 : _ref42$size,
    rest = _objectWithoutProperties(_ref42, _excluded42);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27,19.001A4.0056,4.0056,0,0,0,22.9991,15H9.0011A2.0031,2.0031,0,0,1,7,12.9991V9.858A3.9949,3.9949,0,0,0,9.8581,7h12.284a4,4,0,1,0,0-2H9.8581A3.9916,3.9916,0,1,0,5,9.858v3.1411A4.0057,4.0057,0,0,0,9.0011,17h13.998A2.003,2.003,0,0,1,25,19.001V22H22v3H9.8581a4,4,0,1,0,0,2H22v3h8V22H27ZM26,4a2,2,0,1,1-2,2A2.0019,2.0019,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2.0019,2.0019,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2.002,2.002,0,0,1,6,28Zm22-4v4H24V24Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScisControlTower = /*#__PURE__*/React.forwardRef(function ScisControlTower(_ref43, ref) {
  var children = _ref43.children,
    _ref43$size = _ref43.size,
    size = _ref43$size === void 0 ? 16 : _ref43$size,
    rest = _objectWithoutProperties(_ref43, _excluded43);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M27,19c-0.3,0-0.7,0.1-1,0.2L20.4,12c1-1.1,1.6-2.5,1.6-4c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,1.6,0.6,3,1.6,4L6,19.2 C5.7,19.1,5.3,19,5,19c-1.7,0-3,1.3-3,3s1.3,3,3,3s3-1.3,3-3c0-0.6-0.2-1.1-0.5-1.6l5.6-7.1c0.6,0.3,1.2,0.5,1.9,0.6v10.3 c-1.2,0.4-2,1.5-2,2.8c0,1.7,1.3,3,3,3s3-1.3,3-3c0-1.3-0.8-2.4-2-2.8V13.9c0.7-0.1,1.3-0.3,1.9-0.6l5.6,7.1c-0.3,0.5-0.5,1-0.5,1.6 c0,1.7,1.3,3,3,3s3-1.3,3-3S28.7,19,27,19z M16,4c2.2,0,4,1.8,4,4s-1.8,4-4,4s-4-1.8-4-4S13.8,4,16,4z M5,23c-0.6,0-1-0.4-1-1 s0.4-1,1-1s1,0.4,1,1S5.6,23,5,23z M16,28c-0.6,0-1-0.4-1-1s0.4-1,1-1s1,0.4,1,1S16.6,28,16,28z M27,23c-0.6,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S27.6,23,27,23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScisTransparentSupply = /*#__PURE__*/React.forwardRef(function ScisTransparentSupply(_ref44, ref) {
  var children = _ref44.children,
    _ref44$size = _ref44.size,
    size = _ref44$size === void 0 ? 16 : _ref44$size,
    rest = _objectWithoutProperties(_ref44, _excluded44);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M23,23v3H8.5a4.5,4.5,0,0,1,0-9H9V15H8.5a6.5,6.5,0,0,0,0,13H23v3h8V23Zm6,6H25V25h4Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22H19V19H13v3H11V19a2.0023 2.0023 0 012-2h6a2.0023 2.0023 0 012 2zM16 16a3 3 0 113-3A3.0033 3.0033 0 0116 16zm0-4a1 1 0 101 1A1.0013 1.0013 0 0016 12z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,4H9V1H1V9H9V6H23.5a4.5,4.5,0,0,1,0,9H23v2h.5a6.5,6.5,0,0,0,0-13ZM7,7H3V3H7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Scooter = /*#__PURE__*/React.forwardRef(function Scooter(_ref45, ref) {
  var children = _ref45.children,
    _ref45$size = _ref45.size,
    size = _ref45$size === void 0 ? 16 : _ref45$size,
    rest = _objectWithoutProperties(_ref45, _excluded45);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26 28a4 4 0 114-4A4.0045 4.0045 0 0126 28zm0-6a2 2 0 102 2A2.0023 2.0023 0 0026 22zM24 8H18v2h6a1 1 0 010 2H21a1 1 0 00-.98 1.1963l.9241 4.6211L18.4338 22h-2.69l-2.5723-8.5752A1.988 1.988 0 0011.2559 12H6v2h5.2561l.6 2H7a5.0057 5.0057 0 00-5 5v2a1 1 0 001 1H4a4 4 0 008 0h7a1 1 0 00.8574-.4854l3-5a1 1 0 00.1231-.7109L22.22 14H24a3 3 0 000-6zM8 26a2.0025 2.0025 0 01-2-2h4A2.0025 2.0025 0 018 26zM4 22V21a3.0033 3.0033 0 013-3h5.4561l1.2 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScooterFront = /*#__PURE__*/React.forwardRef(function ScooterFront(_ref46, ref) {
  var children = _ref46.children,
    _ref46$size = _ref46.size,
    size = _ref46$size === void 0 ? 16 : _ref46$size,
    rest = _objectWithoutProperties(_ref46, _excluded46);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19H17V28H15z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M23,10V8H20a2.0025,2.0025,0,0,0-2-2H14a2.0025,2.0025,0,0,0-2,2H9v2h3v4.1841A2.9957,2.9957,0,0,0,10,17v7h2V17a1.0008,1.0008,0,0,1,1-1h6a1.0008,1.0008,0,0,1,1,1v7h2V17a2.9957,2.9957,0,0,0-2-2.8159V10ZM18,8v6H14V8Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Screen = /*#__PURE__*/React.forwardRef(function Screen(_ref47, ref) {
  var children = _ref47.children,
    _ref47$size = _ref47.size,
    size = _ref47$size === void 0 ? 16 : _ref47$size,
    rest = _objectWithoutProperties(_ref47, _excluded47);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V22a2,2,0,0,0,2,2h8v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4ZM18,28H14V24h4Zm10-6H4V6H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScreenOff = /*#__PURE__*/React.forwardRef(function ScreenOff(_ref48, ref) {
  var children = _ref48.children,
    _ref48$size = _ref48.size,
    size = _ref48$size === void 0 ? 16 : _ref48$size,
    rest = _objectWithoutProperties(_ref48, _excluded48);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22H11.41L30,3.41,28.59,2l-2,2H4A2,2,0,0,0,2,6V22H4V6H24.59L2,28.59,3.41,30l6-6H12v4H8v2H24V28H20V24h8a2,2,0,0,0,2-2V9H28ZM18,28H14V24h4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScreenMap = /*#__PURE__*/React.forwardRef(function ScreenMap(_ref49, ref) {
  var children = _ref49.children,
    _ref49$size = _ref49.size,
    size = _ref49$size === void 0 ? 16 : _ref49$size,
    rest = _objectWithoutProperties(_ref49, _excluded49);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M22 25H30V27H22zM22 21H30V23H22zM18.4141 11L23 11 23 9 15 9 15 17 17 17 17 12.4141 23.5859 19 25 17.5859 18.4141 11z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M28,3H4c-1.1028,0-2,.8975-2,2V21c0,1.1025,.8972,2,2,2H12v4h-4v2h12v-8H4V5H28v14h2V5c0-1.1025-.8972-2-2-2Zm-10,24h-4v-4h4v4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScreenMapSet = /*#__PURE__*/React.forwardRef(function ScreenMapSet(_ref50, ref) {
  var children = _ref50.children,
    _ref50$size = _ref50.size,
    size = _ref50$size === void 0 ? 16 : _ref50$size,
    rest = _objectWithoutProperties(_ref50, _excluded50);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H31V28H24zM24 22H31V24H24zM20.4141 12L25 12 25 10 17 10 17 18 19 18 19 13.4141 25.5859 20 27 18.5859 20.4141 12z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M7,7H29v12h2V7c0-1.1025-.8972-2-2-2H7c-1.1028,0-2,.8975-2,2v15c0,1.1025,.8972,2,2,2h7v4h-4v2h12v-8H7V7Zm13,21h-4v-4h4v4Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M26,3V1H3C1.8972,1,1,1.8965,1,3v15H3V3H26Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Script = /*#__PURE__*/React.forwardRef(function Script(_ref51, ref) {
  var children = _ref51.children,
    _ref51$size = _ref51.size,
    size = _ref51$size === void 0 ? 16 : _ref51$size,
    rest = _objectWithoutProperties(_ref51, _excluded51);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28H8V4h8v6a2.0058,2.0058,0,0,0,2,2h6v6h2V10a.9092.9092,0,0,0-.3-.7l-7-7A.9087.9087,0,0,0,18,2H8A2.0058,2.0058,0,0,0,6,4V28a2.0058,2.0058,0,0,0,2,2h6ZM18,4.4,23.6,10H18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ScriptReference = /*#__PURE__*/React.forwardRef(function ScriptReference(_ref52, ref) {
  var children = _ref52.children,
    _ref52$size = _ref52.size,
    size = _ref52$size === void 0 ? 16 : _ref52$size,
    rest = _objectWithoutProperties(_ref52, _excluded52);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20zM27.17 26L24.59 28.58 26 30 30 26 26 22 24.58 23.41 27.17 26zM18.83 26L21.41 23.42 20 22 16 26 20 30 21.42 28.59 18.83 26zM25.7 9.3l-7-7A.9087.9087 0 0018 2H8A2.0058 2.0058 0 006 4V16H8V4h8v6a2.0058 2.0058 0 002 2h6v6h2V10A.9092.9092 0 0025.7 9.3zM18 10V4.4L23.6 10z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Sdk = /*#__PURE__*/React.forwardRef(function Sdk(_ref53, ref) {
  var children = _ref53.children,
    _ref53$size = _ref53.size,
    size = _ref53$size === void 0 ? 16 : _ref53$size,
    rest = _objectWithoutProperties(_ref53, _excluded53);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9L27.9 9 24 15.6 24 9 22 9 22 23 24 23 24 18.7 24.9 17.2 27.9 23 30 23 26.1 15.4 30 9zM16 23H12V9h4a4.0118 4.0118 0 014 4v6A4.0118 4.0118 0 0116 23zm-2-2h2a2.0059 2.0059 0 002-2V13a2.0059 2.0059 0 00-2-2H14zM8 23H2V21H8V17H4a2.0059 2.0059 0 01-2-2V11A2.0059 2.0059 0 014 9h6v2H4v4H8a2.0059 2.0059 0 012 2v4A2.0059 2.0059 0 018 23z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Search = /*#__PURE__*/React.forwardRef(function Search(_ref54, ref) {
  var children = _ref54.children,
    _ref54$size = _ref54.size,
    size = _ref54$size === void 0 ? 16 : _ref54$size,
    rest = _objectWithoutProperties(_ref54, _excluded54);
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
      d: "M15,14.3L10.7,10c1.9-2.3,1.6-5.8-0.7-7.7S4.2,0.7,2.3,3S0.7,8.8,3,10.7c2,1.7,5,1.7,7,0l4.3,4.3L15,14.3z M2,6.5 C2,4,4,2,6.5,2S11,4,11,6.5S9,11,6.5,11S2,9,2,6.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M29,27.5859l-7.5521-7.5521a11.0177,11.0177,0,1,0-1.4141,1.4141L27.5859,29ZM4,13a9,9,0,1,1,9,9A9.01,9.01,0,0,1,4,13Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SearchAdvanced = /*#__PURE__*/React.forwardRef(function SearchAdvanced(_ref55, ref) {
  var children = _ref55.children,
    _ref55$size = _ref55.size,
    size = _ref55$size === void 0 ? 16 : _ref55$size,
    rest = _objectWithoutProperties(_ref55, _excluded55);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6L26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6zM24 28.5859l-5.9751-5.9751a9.0234 9.0234 0 10-1.4141 1.4141L22.5859 30zM4 17a7 7 0 117 7A7.0078 7.0078 0 014 17z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SearchLocate = /*#__PURE__*/React.forwardRef(function SearchLocate(_ref56, ref) {
  var children = _ref56.children,
    _ref56$size = _ref56.size,
    size = _ref56$size === void 0 ? 16 : _ref56$size,
    rest = _objectWithoutProperties(_ref56, _excluded56);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M30 28.5859l-4.6885-4.6884a8.028 8.028 0 10-1.414 1.414L28.5859 30zM19 25a6 6 0 116-6A6.0066 6.0066 0 0119 25zM2 12H10V14H2zM2 2H18V4H2zM2 7H18V9H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SearchLocateMirror = /*#__PURE__*/React.forwardRef(function SearchLocateMirror(_ref57, ref) {
  var children = _ref57.children,
    _ref57$size = _ref57.size,
    size = _ref57$size === void 0 ? 16 : _ref57$size,
    rest = _objectWithoutProperties(_ref57, _excluded57);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M21 28.6l-4.7-4.7c1.1-1.4 1.7-3.1 1.7-4.9 0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8c1.8 0 3.5-.6 4.9-1.7l4.7 4.7L21 28.6zM10 25c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6S13.3 25 10 25zM22 12H30V14H22zM14 7H30V9H14zM14 2H30V4H14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Security = /*#__PURE__*/React.forwardRef(function Security(_ref58, ref) {
  var children = _ref58.children,
    _ref58$size = _ref58.size,
    size = _ref58$size === void 0 ? 16 : _ref58$size,
    rest = _objectWithoutProperties(_ref58, _excluded58);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.59L11.41 14 10 15.41 14 19.41 22 11.41 20.59 10 14 16.59z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,9.8242,26.7071A10.9818,10.9818,0,0,1,4,17V4A2.0021,2.0021,0,0,1,6,2H26a2.0021,2.0021,0,0,1,2,2V17a10.9818,10.9818,0,0,1-5.8242,9.7071ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SecurityServices = /*#__PURE__*/React.forwardRef(function SecurityServices(_ref59, ref) {
  var children = _ref59.children,
    _ref59$size = _ref59.size,
    size = _ref59$size === void 0 ? 16 : _ref59$size,
    rest = _objectWithoutProperties(_ref59, _excluded59);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24V22H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,18.1011V16H22v2.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,22H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,27.8989V30h2V27.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,24Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,26Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14,26.667l-3.2344-1.7246A8.9858,8.9858,0,0,1,6,17V4H26V14h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,28.9336Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Select_01 = /*#__PURE__*/React.forwardRef(function Select_01(_ref60, ref) {
  var children = _ref60.children,
    _ref60$size = _ref60.size,
    size = _ref60$size === void 0 ? 16 : _ref60$size,
    rest = _objectWithoutProperties(_ref60, _excluded60);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM16 6H20V8H16zM24 6V8h4v4h2V8a2 2 0 00-2-2zM6 16H8V20H6zM8 28V24H6v4a2 2 0 002 2h4V28zM28 16H30V20H28zM16 28H20V30H16zM28 24v4H24v2h4a2 2 0 002-2V24z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Select_02 = /*#__PURE__*/React.forwardRef(function Select_02(_ref61, ref) {
  var children = _ref61.children,
    _ref61$size = _ref61.size,
    size = _ref61$size === void 0 ? 16 : _ref61$size,
    rest = _objectWithoutProperties(_ref61, _excluded61);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L8 6 8 2 6 2 6 6 2 6 2 8 6 8 6 12 8 12 8 8 12 8 12 6zM30 10V4H24V6H16V8h8v2h2V24H24v2H10V24H8V16H6v8H4v6h6V28H24v2h6V24H28V10zM8 28H6V26H8zm20 0H26V26h2zM26 6h2V8H26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SelectWindow = /*#__PURE__*/React.forwardRef(function SelectWindow(_ref62, ref) {
  var children = _ref62.children,
    _ref62$size = _ref62.size,
    size = _ref62$size === void 0 ? 16 : _ref62$size,
    rest = _objectWithoutProperties(_ref62, _excluded62);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M8 26H4a2.0021 2.0021 0 01-2-2V20H4v4H8zM2 12H4V16H2zM26 8H24V4H20V2h4a2.0021 2.0021 0 012 2zM12 2H16V4H12zM4 8H2V4A2.0021 2.0021 0 014 2H8V4H4zM27 32a.9967.9967 0 01-.707-.293l-6.1377-6.1377L16.832 30.5547a1 1 0 01-1.79-.2676l-6-20A1 1 0 0110.2871 9.042l20 6a1 1 0 01.2676 1.79l-4.9854 3.3233L31.707 26.293a.9994.9994 0 010 1.414l-4 4A.9967.9967 0 0127 32zm0-2.4141L29.5859 27 22.431 19.845l5.2458-3.4978L11.4917 11.4917l4.8555 16.1851L19.845 22.431z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Send = /*#__PURE__*/React.forwardRef(function Send(_ref63, ref) {
  var children = _ref63.children,
    _ref63$size = _ref63.size,
    size = _ref63$size === void 0 ? 16 : _ref63$size,
    rest = _objectWithoutProperties(_ref63, _excluded63);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L7,16,4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Zm-20.9,10L8.76,17H18V15H8.76L6.55,6.89,24.76,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SendAlt = /*#__PURE__*/React.forwardRef(function SendAlt(_ref64, ref) {
  var children = _ref64.children,
    _ref64$size = _ref64.size,
    size = _ref64$size === void 0 ? 16 : _ref64$size,
    rest = _objectWithoutProperties(_ref64, _excluded64);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l9.6,3.84,3.84,9.6A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29ZM19,24.2l-2.79-7L21,12.41,19.59,11l-4.83,4.83L7.8,13,25.33,6.67Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SendAltFilled = /*#__PURE__*/React.forwardRef(function SendAltFilled(_ref65, ref) {
  var children = _ref65.children,
    _ref65$size = _ref65.size,
    size = _ref65$size === void 0 ? 16 : _ref65$size,
    rest = _objectWithoutProperties(_ref65, _excluded65);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M27.71,4.29a1,1,0,0,0-1.05-.23l-22,8a1,1,0,0,0,0,1.87l8.59,3.43L19.59,11,21,12.41l-6.37,6.37,3.44,8.59A1,1,0,0,0,19,28h0a1,1,0,0,0,.92-.66l8-22A1,1,0,0,0,27.71,4.29Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SendFilled = /*#__PURE__*/React.forwardRef(function SendFilled(_ref66, ref) {
  var children = _ref66.children,
    _ref66$size = _ref66.size,
    size = _ref66$size === void 0 ? 16 : _ref66$size,
    rest = _objectWithoutProperties(_ref66, _excluded66);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M27.45,15.11l-22-11a1,1,0,0,0-1.08.12,1,1,0,0,0-.33,1L6.69,15H18v2H6.69L4,26.74A1,1,0,0,0,5,28a1,1,0,0,0,.45-.11l22-11a1,1,0,0,0,0-1.78Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SendActionUsage = /*#__PURE__*/React.forwardRef(function SendActionUsage(_ref67, ref) {
  var children = _ref67.children,
    _ref67$size = _ref67.size,
    size = _ref67$size === void 0 ? 16 : _ref67$size,
    rest = _objectWithoutProperties(_ref67, _excluded67);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9,21c-.5523,0-1-.4477-1-1v-8c0-.5523.4477-1,1-1h11.1716c.5304,0,1.0391.2107,1.4142.5858l4.4142,4.4142-4.4142,4.4142c-.3751.3751-.8838.5858-1.4142.5858h-11.1715Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SendBackward = /*#__PURE__*/React.forwardRef(function SendBackward(_ref68, ref) {
  var children = _ref68.children,
    _ref68$size = _ref68.size,
    size = _ref68$size === void 0 ? 16 : _ref68$size,
    rest = _objectWithoutProperties(_ref68, _excluded68);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7H2V4A2.0023 2.0023 0 014 2H7V4H4zM7 22H4a2.0023 2.0023 0 01-2-2V17H4v3H7zM2 10H4V14H2zM22 7H20V4H17V2h3a2.0023 2.0023 0 012 2zM10 2H14V4H10zM28 30H12a2.0023 2.0023 0 01-2-2V12a2.0023 2.0023 0 012-2H28a2.0023 2.0023 0 012 2V28A2.0023 2.0023 0 0128 30zM12 12V28H28V12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SendToBack = /*#__PURE__*/React.forwardRef(function SendToBack(_ref69, ref) {
  var children = _ref69.children,
    _ref69$size = _ref69.size,
    size = _ref69$size === void 0 ? 16 : _ref69$size,
    rest = _objectWithoutProperties(_ref69, _excluded69);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,28,10ZM12,28V12H28l.0015,16Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ServerDns = /*#__PURE__*/React.forwardRef(function ServerDns(_ref70, ref) {
  var children = _ref70.children,
    _ref70$size = _ref70.size,
    size = _ref70$size === void 0 ? 16 : _ref70$size,
    rest = _objectWithoutProperties(_ref70, _excluded70);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2a8 8 0 108 8A8.0092 8.0092 0 0016 2zm5.91 7H19.4724a15.2457 15.2457 0 00-.7917-4.36A6.0088 6.0088 0 0121.91 9zM16.022 15.999h-.0076c-.3813-.1206-1.3091-1.8213-1.479-4.999h2.9292C17.2952 14.1763 16.3711 15.877 16.022 15.999zM14.5354 9c.1694-3.1763 1.0935-4.877 1.4426-4.999h.0076c.3813.1206 1.3091 1.8213 1.479 4.999zM13.3193 4.64A15.2457 15.2457 0 0012.5276 9H10.09A6.0088 6.0088 0 0113.3193 4.64zM10.09 11h2.4373a15.2457 15.2457 0 00.7917 4.36A6.0088 6.0088 0 0110.09 11zm8.59 4.36A15.2457 15.2457 0 0019.4724 11H21.91A6.0088 6.0088 0 0118.6807 15.36zM28 30H4a2.0021 2.0021 0 01-2-2V22a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v6A2.0021 2.0021 0 0128 30zM4 22v6H28V22z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ServerProxy = /*#__PURE__*/React.forwardRef(function ServerProxy(_ref71, ref) {
  var children = _ref71.children,
    _ref71$size = _ref71.size,
    size = _ref71$size === void 0 ? 16 : _ref71$size,
    rest = _objectWithoutProperties(_ref71, _excluded71);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H26a2,2,0,0,0,2-2V22a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v6A2,2,0,0,0,6,30Zm0-8H26v6H6Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "25",
    r: "1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2,24.59,3.41,27.17,6H22.315A6.9835,6.9835,0,0,0,9.08,10H4.83L7.41,7.41,6,6,1,11l5,5,1.41-1.41L4.83,12H9.685A6.9835,6.9835,0,0,0,22.92,8h4.25l-2.58,2.59L26,12l5-5ZM21,9a4.983,4.983,0,0,1-8.9745,3H16V10H11.1011a4.9852,4.9852,0,0,1,8.8734-4H16V8h4.8989A5.0019,5.0019,0,0,1,21,9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ServerTime = /*#__PURE__*/React.forwardRef(function ServerTime(_ref72, ref) {
  var children = _ref72.children,
    _ref72$size = _ref72.size,
    size = _ref72$size === void 0 ? 16 : _ref72$size,
    rest = _objectWithoutProperties(_ref72, _excluded72);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM4,22v6H28V22Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.586L17 9.586 17 6 15 6 15 10.414 17.586 13 19 11.586z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M16,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,18ZM16,4a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ServiceDesk = /*#__PURE__*/React.forwardRef(function ServiceDesk(_ref73, ref) {
  var children = _ref73.children,
    _ref73$size = _ref73.size,
    size = _ref73$size === void 0 ? 16 : _ref73$size,
    rest = _objectWithoutProperties(_ref73, _excluded73);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M28,24V22A12.01,12.01,0,0,0,17,10.0507V8h3V6H12V8h3v2.0507A12.01,12.01,0,0,0,4,22v2H2v2H30V24ZM16,12a10.0167,10.0167,0,0,1,9.7984,8H6.2015A10.0165,10.0165,0,0,1,16,12ZM6,22H26v2H6Z",
    transform: "translate(0 .005)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ServiceId = /*#__PURE__*/React.forwardRef(function ServiceId(_ref74, ref) {
  var children = _ref74.children,
    _ref74$size = _ref74.size,
    size = _ref74$size === void 0 ? 16 : _ref74$size,
    rest = _objectWithoutProperties(_ref74, _excluded74);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24v-2h-2.101c-.13-.637-.384-1.229-.732-1.753l1.49-1.49-1.414-1.414-1.49 1.49c-.524-.348-1.116-.602-1.753-.732V16h-2v2.101c-.637.13-1.229.384-1.753.732l-1.49-1.49-1.414 1.414 1.49 1.49c-.348.524-.602 1.116-.732 1.753H16v2h2.101c.13.637.384 1.229.732 1.753l-1.49 1.49 1.414 1.414 1.49-1.49c.524.348 1.116.602 1.753.732V30h2v-2.101c.637-.13 1.229-.384 1.753-.732l1.49 1.49 1.414-1.414-1.49-1.49c.348-.524.602-1.116.732-1.753H30zM23 26c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3S24.654 26 23 26zM12 6H16V8H12z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M6,28V4h16v9h2V4c0-1.103-0.897-2-2-2H6C4.897,2,4,2.897,4,4v24c0,1.103,0.897,2,2,2h8v-2H6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ServiceLevels = /*#__PURE__*/React.forwardRef(function ServiceLevels(_ref75, ref) {
  var children = _ref75.children,
    _ref75$size = _ref75.size,
    size = _ref75$size === void 0 ? 16 : _ref75$size,
    rest = _objectWithoutProperties(_ref75, _excluded75);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "19",
    r: "1"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "11",
    r: "1"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "19",
    r: "1"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "14",
    r: "1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20h-2c0-1.2616-.1946-2.5042-.5786-3.6929l1.9033-.6146c.448 1.3876.6753 2.8369.6753 4.3075zM29.8508 8.9775l-2.4368 2.4365-.0005-.0005c-.3621.3623-.8621.5864-1.4136.5864-1.103 0-2-.897-2-2 0-.5518.2241-1.0518.5864-1.4136l-.0005-.0005 2.4368-2.4365c-.3284-.0879-.667-.1494-1.0227-.1494-2.2056 0-4 1.7944-4 4 0 .7393.2153 1.4238.5669 2.019l-4.5479 4.5479c-.595-.3516-1.2795-.5669-2.019-.5669-2.2056 0-4 1.7944-4 4s1.7944 4 4 4 4-1.7944 4-4c0-.7397-.2153-1.4243-.5669-2.019l4.5479-4.5479c.595.3516 1.2795.5669 2.019.5669 2.2056 0 4-1.7944 4-4 0-.3555-.0615-.6943-.1492-1.0225zm-13.8508 13.0225c-1.103 0-2-.8975-2-2s.897-2 2-2 2 .8975 2 2-.897 2-2 2zM4 20h-2c0-7.7196 6.2803-14 14-14 1.4707 0 2.9199.2272 4.3074.6754l-.6147 1.9031c-1.1885-.3838-2.4309-.5785-3.6926-.5785-6.6167 0-12 5.3832-12 12z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SessionBorderControl = /*#__PURE__*/React.forwardRef(function SessionBorderControl(_ref76, ref) {
  var children = _ref76.children,
    _ref76$size = _ref76.size,
    size = _ref76$size === void 0 ? 16 : _ref76$size,
    rest = _objectWithoutProperties(_ref76, _excluded76);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M26,8,24.59,9.41,27.17,12H16a5.967,5.967,0,0,0-4,1.54V6.83l2.59,2.58L16,8,11,3,6,8,7.41,9.41,10,6.83V18a5.969,5.969,0,0,0,1.54,4H4.83l2.58-2.59L6,18,1,23l5,5,1.41-1.41L4.83,24H16A5.99,5.99,0,0,0,20.46,14h6.71l-2.58,2.59L26,18l5-5ZM20,18a4,4,0,1,1-4-4A4.0045,4.0045,0,0,1,20,18Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Settings = /*#__PURE__*/React.forwardRef(function Settings(_ref77, ref) {
  var children = _ref77.children,
    _ref77$size = _ref77.size,
    size = _ref77$size === void 0 ? 16 : _ref77$size,
    rest = _objectWithoutProperties(_ref77, _excluded77);
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, _objectSpread({
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor"
    }, rest), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
      d: "M13.5,8.4c0-0.1,0-0.3,0-0.4c0-0.1,0-0.3,0-0.4l1-0.8c0.4-0.3,0.4-0.9,0.2-1.3l-1.2-2C13.3,3.2,13,3,12.6,3 c-0.1,0-0.2,0-0.3,0.1l-1.2,0.4c-0.2-0.1-0.4-0.3-0.7-0.4l-0.3-1.3C10.1,1.3,9.7,1,9.2,1H6.8c-0.5,0-0.9,0.3-1,0.8L5.6,3.1 C5.3,3.2,5.1,3.3,4.9,3.4L3.7,3C3.6,3,3.5,3,3.4,3C3,3,2.7,3.2,2.5,3.5l-1.2,2C1.1,5.9,1.2,6.4,1.6,6.8l0.9,0.9c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.3,0,0.4L1.6,9.2c-0.4,0.3-0.5,0.9-0.2,1.3l1.2,2C2.7,12.8,3,13,3.4,13c0.1,0,0.2,0,0.3-0.1l1.2-0.4 c0.2,0.1,0.4,0.3,0.7,0.4l0.3,1.3c0.1,0.5,0.5,0.8,1,0.8h2.4c0.5,0,0.9-0.3,1-0.8l0.3-1.3c0.2-0.1,0.4-0.2,0.7-0.4l1.2,0.4 c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.7-0.2,0.9-0.5l1.1-2c0.2-0.4,0.2-0.9-0.2-1.3L13.5,8.4z M12.6,12l-1.7-0.6c-0.4,0.3-0.9,0.6-1.4,0.8 L9.2,14H6.8l-0.4-1.8c-0.5-0.2-0.9-0.5-1.4-0.8L3.4,12l-1.2-2l1.4-1.2c-0.1-0.5-0.1-1.1,0-1.6L2.2,6l1.2-2l1.7,0.6 C5.5,4.2,6,4,6.5,3.8L6.8,2h2.4l0.4,1.8c0.5,0.2,0.9,0.5,1.4,0.8L12.6,4l1.2,2l-1.4,1.2c0.1,0.5,0.1,1.1,0,1.6l1.4,1.2L12.6,12z"
    })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
      d: "M8,11c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3C11,9.6,9.7,11,8,11C8,11,8,11,8,11z M8,6C6.9,6,6,6.8,6,7.9C6,7.9,6,8,6,8 c0,1.1,0.8,2,1.9,2c0,0,0.1,0,0.1,0c1.1,0,2-0.8,2-1.9c0,0,0-0.1,0-0.1C10,6.9,9.2,6,8,6C8.1,6,8,6,8,6z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M27,16.76c0-.25,0-.5,0-.76s0-.51,0-.77l1.92-1.68A2,2,0,0,0,29.3,11L26.94,7a2,2,0,0,0-1.73-1,2,2,0,0,0-.64.1l-2.43.82a11.35,11.35,0,0,0-1.31-.75l-.51-2.52a2,2,0,0,0-2-1.61H13.64a2,2,0,0,0-2,1.61l-.51,2.52a11.48,11.48,0,0,0-1.32.75L7.43,6.06A2,2,0,0,0,6.79,6,2,2,0,0,0,5.06,7L2.7,11a2,2,0,0,0,.41,2.51L5,15.24c0,.25,0,.5,0,.76s0,.51,0,.77L3.11,18.45A2,2,0,0,0,2.7,21L5.06,25a2,2,0,0,0,1.73,1,2,2,0,0,0,.64-.1l2.43-.82a11.35,11.35,0,0,0,1.31.75l.51,2.52a2,2,0,0,0,2,1.61h4.72a2,2,0,0,0,2-1.61l.51-2.52a11.48,11.48,0,0,0,1.32-.75l2.42.82a2,2,0,0,0,.64.1,2,2,0,0,0,1.73-1L29.3,21a2,2,0,0,0-.41-2.51ZM25.21,24l-3.43-1.16a8.86,8.86,0,0,1-2.71,1.57L18.36,28H13.64l-.71-3.55a9.36,9.36,0,0,1-2.7-1.57L6.79,24,4.43,20l2.72-2.4a8.9,8.9,0,0,1,0-3.13L4.43,12,6.79,8l3.43,1.16a8.86,8.86,0,0,1,2.71-1.57L13.64,4h4.72l.71,3.55a9.36,9.36,0,0,1,2.7,1.57L25.21,8,27.57,12l-2.72,2.4a8.9,8.9,0,0,1,0,3.13L27.57,20Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A5.94,5.94,0,0,1,16,22Zm0-10a3.91,3.91,0,0,0-4,4,3.91,3.91,0,0,0,4,4,3.91,3.91,0,0,0,4-4A3.91,3.91,0,0,0,16,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SettingsAdjust = /*#__PURE__*/React.forwardRef(function SettingsAdjust(_ref78, ref) {
  var children = _ref78.children,
    _ref78$size = _ref78.size,
    size = _ref78$size === void 0 ? 16 : _ref78$size,
    rest = _objectWithoutProperties(_ref78, _excluded78);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M30 8h-4.1c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2v2h14.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30V8zM21 12c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3S22.7 12 21 12zM2 24h4.1c.5 2.3 2.5 4 4.9 4s4.4-1.7 4.9-4H30v-2H15.9c-.5-2.3-2.5-4-4.9-4s-4.4 1.7-4.9 4H2V24zM11 20c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3S9.3 20 11 20z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SettingsCheck = /*#__PURE__*/React.forwardRef(function SettingsCheck(_ref79, ref) {
  var children = _ref79.children,
    _ref79$size = _ref79.size,
    size = _ref79$size === void 0 ? 16 : _ref79$size,
    rest = _objectWithoutProperties(_ref79, _excluded79);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A5.9364,5.9364,0,0,1,16,22Zm0-10a3.9123,3.9123,0,0,0-4,4,3.9123,3.9123,0,0,0,4,4,3.9123,3.9123,0,0,0,4-4A3.9123,3.9123,0,0,0,16,12Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.044,26.9441,6.9562a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583L20.3215,3.608A2,2,0,0,0,18.36,2H13.64A2,2,0,0,0,11.6785,3.608l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0616a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.044a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4947,5,15.7447,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025L5.0559,25.044a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H18V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713L6.7878,24.044l-2.36-4.0878,2.7253-2.3951a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.044,6.7886,7.9562l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.044Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26.18L20.41 23.59 19 25 23 29 30 22 28.59 20.59 23 26.18z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SettingsEdit = /*#__PURE__*/React.forwardRef(function SettingsEdit(_ref80, ref) {
  var children = _ref80.children,
    _ref80$size = _ref80.size,
    size = _ref80$size === void 0 ? 16 : _ref80$size,
    rest = _objectWithoutProperties(_ref80, _excluded80);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M31.707 19.2929l-3-3c-.3906-.3906-1.0234-.3906-1.4141 0l-9.293 9.293v4.4141h4.4141l9.293-9.293c.3906-.3906.3906-1.0234 0-1.4141zm-10.1211 8.707h-1.5859v-1.5859l5-5 1.5859 1.5859-5 5zm6.4141-6.4141l-1.5859-1.5859 1.5859-1.5859 1.5859 1.5859-1.5859 1.5859zM16 22c-3.3643 0-6-2.6357-6-6s2.6357-6 6-6 6 2.6357 6 6-2.6357 6-6 6zm0-10c-2.2803 0-4 1.7197-4 4s1.7197 4 4 4 4-1.7197 4-4-1.7197-4-4-4z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "m27.5474,12.0005l1.7322-1-2.3354-4.0444c-.3652-.6328-1.0334-1.0005-1.7322-1.0005-.2134,0-.4294.0342-.6406.106l-2.4341.8232c-.418-.2812-.856-.5352-1.312-.7583l-.5037-2.5186c-.187-.9351-1.0078-1.6079-1.9612-1.6079h-4.7207c-.9534,0-1.7742.6729-1.9612,1.6079l-.5037,2.5186c-.459.2246-.9062.4692-1.3267.7534l-2.4194-.8184c-.2112-.0718-.4272-.106-.6406-.106-.6987,0-1.3669.3677-1.7322,1.0005l-2.3606,4.0879c-.4766.8257-.3042,1.873.4119,2.5024l1.9309,1.6968c-.0171.2515-.0381.5015-.0381.7568,0,.2578.0103.5127.0278.7656l-1.9207,1.688c-.7161.6294-.8884,1.6768-.4119,2.5024l2.3606,4.0879c.3652.6328,1.0334,1.0005,1.7322,1.0005.2134,0,.4297-.0342.6406-.106l2.4341-.8232c.418.2817.856.5352,1.312.7583l.5037,2.5186c.187.9351,1.0078,1.6079,1.9612,1.6079h2.3604v-2h-2.3604l-.7102-3.5508c-.9753-.356-1.9026-.9062-2.6948-1.5713l-3.4468,1.166-2.3604-4.0879,2.7253-2.395c-.1838-1.043-.1914-2.083-.0071-3.1279l-2.7183-2.3892,2.3611-4.0879,3.4268,1.1592c.8032-.6763,1.7295-1.2051,2.7141-1.5645l.7102-3.5508h4.7207l.7102,3.5508c.9753.356,1.9023.9062,2.6948,1.5713l3.4468-1.166,2.3352,4.0444Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SettingsServices = /*#__PURE__*/React.forwardRef(function SettingsServices(_ref81, ref) {
  var children = _ref81.children,
    _ref81$size = _ref81.size,
    size = _ref81$size === void 0 ? 16 : _ref81$size,
    rest = _objectWithoutProperties(_ref81, _excluded81);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M29,25H27V23h1V19H24v1H22V18a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,29,25Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30H18a1 1 0 01-1-1V23a1 1 0 011-1h6a1 1 0 011 1v6A1 1 0 0124 30zm-5-2h4V24H19zM15 19.8579A3.9934 3.9934 0 1120 16h2a6 6 0 10-7 5.91z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M28.89,13.55l-2.31,2.03-1.42-1.42,2.41-2.12L25.21,7.96,21.77,9.12a9.3684,9.3684,0,0,0-2.7-1.57L18.36,4H13.64l-.71,3.55a8.8609,8.8609,0,0,0-2.71,1.57L6.79,7.96,4.43,12.04l2.72,2.39a8.8948,8.8948,0,0,0,0,3.13l-2.72,2.4,2.36,4.08,3.44-1.16a9.3684,9.3684,0,0,0,2.7,1.57L13.64,28H15v2H13.64a2.0007,2.0007,0,0,1-1.96-1.61l-.51-2.52a11.412,11.412,0,0,1-1.31-.75l-2.43.82a2.038,2.038,0,0,1-.64.1,1.973,1.973,0,0,1-1.73-1L2.7,20.96a2,2,0,0,1,.41-2.51l1.92-1.68C5.01,16.51,5,16.26,5,16s.02-.51.04-.76L3.11,13.55a2,2,0,0,1-.41-2.51L5.06,6.96a1.973,1.973,0,0,1,1.73-1,2.038,2.038,0,0,1,.64.1l2.42.82a11.5416,11.5416,0,0,1,1.32-.75l.51-2.52A2.0007,2.0007,0,0,1,13.64,2h4.72a2.0007,2.0007,0,0,1,1.96,1.61l.51,2.52a11.412,11.412,0,0,1,1.31.75l2.43-.82a2.038,2.038,0,0,1,.64-.1,1.973,1.973,0,0,1,1.73,1l2.36,4.08A2,2,0,0,1,28.89,13.55Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SettingsView = /*#__PURE__*/React.forwardRef(function SettingsView(_ref82, ref) {
  var children = _ref82.children,
    _ref82$size = _ref82.size,
    size = _ref82$size === void 0 ? 16 : _ref82$size,
    rest = _objectWithoutProperties(_ref82, _excluded82);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "24",
    r: "2"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7769 23.4785A8.64 8.64 0 0023 18a8.64 8.64 0 00-7.7769 5.4785L15 24l.2231.5215A8.64 8.64 0 0023 30a8.64 8.64 0 007.7769-5.4785L31 24zM23 28a4 4 0 114-4A4.0045 4.0045 0 0123 28zM12.3989 20.8A6 6 0 1122 16H20a4 4 0 10-6.4 3.2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3047,11.0439,26.9441,6.9561a1.9977,1.9977,0,0,0-2.3728-.8946l-2.4341.8233a11.0419,11.0419,0,0,0-1.312-.7583l-.5037-2.5186A2,2,0,0,0,18.36,2H13.64a2,2,0,0,0-1.9611,1.6079l-.5037,2.5186A10.9666,10.9666,0,0,0,9.8481,6.88L7.4287,6.0615a1.9977,1.9977,0,0,0-2.3728.8946L2.6953,11.0439a2.0006,2.0006,0,0,0,.4119,2.5025l1.9309,1.6968C5.021,15.4946,5,15.7446,5,16c0,.2578.01.5127.0278.7656l-1.9206,1.688a2.0006,2.0006,0,0,0-.4119,2.5025l2.3606,4.0878a1.9977,1.9977,0,0,0,2.3728.8946l2.4341-.8233a10.9736,10.9736,0,0,0,1.312.7583l.5037,2.5186A2,2,0,0,0,13.64,30H15V28H13.64l-.71-3.5508a9.0953,9.0953,0,0,1-2.6948-1.5713l-3.4468,1.166-2.36-4.0878L7.1528,17.561a8.9263,8.9263,0,0,1-.007-3.1279L4.4275,12.0439,6.7886,7.9561l3.4267,1.1591a9.0305,9.0305,0,0,1,2.7141-1.5644L13.64,4H18.36l.71,3.5508a9.0978,9.0978,0,0,1,2.6948,1.5713l3.4468-1.166,2.36,4.0878-2.7978,2.4522L26.0923,16l2.8-2.4536A2.0006,2.0006,0,0,0,29.3047,11.0439Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShapeExcept = /*#__PURE__*/React.forwardRef(function ShapeExcept(_ref83, ref) {
  var children = _ref83.children,
    _ref83$size = _ref83.size,
    size = _ref83$size === void 0 ? 16 : _ref83$size,
    rest = _objectWithoutProperties(_ref83, _excluded83);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10ZM12,20V12h8v8ZM3.9988,4H20v6H12a2.0023,2.0023,0,0,0-2,2v8H4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShapeExclude = /*#__PURE__*/React.forwardRef(function ShapeExclude(_ref84, ref) {
  var children = _ref84.children,
    _ref84$size = _ref84.size,
    size = _ref84$size === void 0 ? 16 : _ref84$size,
    rest = _objectWithoutProperties(_ref84, _excluded84);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6V12A2,2,0,0,1,12,10Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V20a2,2,0,0,1-2,2H10v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShapeIntersect = /*#__PURE__*/React.forwardRef(function ShapeIntersect(_ref85, ref) {
  var children = _ref85.children,
    _ref85$size = _ref85.size,
    size = _ref85$size === void 0 ? 16 : _ref85$size,
    rest = _objectWithoutProperties(_ref85, _excluded85);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4H20v6H12a2.0025,2.0025,0,0,0-2,2v8Zm8,8V22h8a2.0025,2.0025,0,0,0,2-2V12h6V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShapeJoin = /*#__PURE__*/React.forwardRef(function ShapeJoin(_ref86, ref) {
  var children = _ref86.children,
    _ref86$size = _ref86.size,
    size = _ref86$size === void 0 ? 16 : _ref86$size,
    rest = _objectWithoutProperties(_ref86, _excluded86);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2.0025,2.0025,0,0,0-2-2H4A2.0025,2.0025,0,0,0,2,4V20a2.0025,2.0025,0,0,0,2,2h6v6a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V12A2.0025,2.0025,0,0,0,28,10ZM4,20V4h6V20Zm18,8V12h6V28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShapeUnite = /*#__PURE__*/React.forwardRef(function ShapeUnite(_ref87, ref) {
  var children = _ref87.children,
    _ref87$size = _ref87.size,
    size = _ref87$size === void 0 ? 16 : _ref87$size,
    rest = _objectWithoutProperties(_ref87, _excluded87);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2h6v6a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A2,2,0,0,0,28,10Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Shapes = /*#__PURE__*/React.forwardRef(function Shapes(_ref88, ref) {
  var children = _ref88.children,
    _ref88$size = _ref88.size,
    size = _ref88$size === void 0 ? 16 : _ref88$size,
    rest = _objectWithoutProperties(_ref88, _excluded88);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M5 16h-2v11c0 1.1045.8954 2 2 2h8v-2H5v-11zM28 29h-11c-.3535 0-.6809-.1866-.8608-.4911-.0927-.1568-.1392-.3328-.1392-.5089 0-.1658.0412-.3317.1238-.4819l5.5-10c.1898-.3451.5333-.5178.8762-.5181.3434-.0003.6861.1724.8762.5181l5.5 10c.0826.1502.1238.3162.1238.4819 0 .1762-.0465.3521-.1392.5089-.1799.3044-.5073.4911-.8608.4911zm-9.3088-2h7.6177l-3.8088-6.9249-3.8088 6.9249zM27 3h-11v2h11v13.9922h2V5c0-1.1045-.8954-2-2-2zM11 3h-6c-1.1046 0-2 .8955-2 2v6c0 1.1045.8954 2 2 2h6c1.1046 0 2-.8955 2-2v-6c0-1.1045-.8954-2-2-2zm0 8h-6v-6h6v6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Share = /*#__PURE__*/React.forwardRef(function Share(_ref89, ref) {
  var children = _ref89.children,
    _ref89$size = _ref89.size,
    size = _ref89$size === void 0 ? 16 : _ref89$size,
    rest = _objectWithoutProperties(_ref89, _excluded89);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20a5,5,0,0,0-3.89,1.89L11.8,17.32a4.46,4.46,0,0,0,0-2.64l7.31-4.57A5,5,0,1,0,18,7a4.79,4.79,0,0,0,.2,1.32l-7.31,4.57a5,5,0,1,0,0,6.22l7.31,4.57A4.79,4.79,0,0,0,18,25a5,5,0,1,0,5-5ZM23,4a3,3,0,1,1-3,3A3,3,0,0,1,23,4ZM7,19a3,3,0,1,1,3-3A3,3,0,0,1,7,19Zm16,9a3,3,0,1,1,3-3A3,3,0,0,1,23,28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShareKnowledge = /*#__PURE__*/React.forwardRef(function ShareKnowledge(_ref90, ref) {
  var children = _ref90.children,
    _ref90$size = _ref90.size,
    size = _ref90$size === void 0 ? 16 : _ref90$size,
    rest = _objectWithoutProperties(_ref90, _excluded90);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25H21a3 3 0 00-3 3v2h2V28a1 1 0 011-1h6a1 1 0 011 1v2h2V28A3 3 0 0027 25zM20 20a4 4 0 104-4A4 4 0 0020 20zm6 0a2 2 0 11-2-2A2 2 0 0126 20zM6 21V20H4v1a7 7 0 007 7h3V26H11A5 5 0 016 21zM19 10H26V12H19zM19 6H29V8H19zM19 2H29V4H19zM11 11H5a3 3 0 00-3 3v2H4V14a1 1 0 011-1h6a1 1 0 011 1v2h2V14A3 3 0 0011 11zM8 10A4 4 0 104 6 4 4 0 008 10zM8 4A2 2 0 116 6 2 2 0 018 4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShoppingBag = /*#__PURE__*/React.forwardRef(function ShoppingBag(_ref91, ref) {
  var children = _ref91.children,
    _ref91$size = _ref91.size,
    size = _ref91$size === void 0 ? 16 : _ref91$size,
    rest = _objectWithoutProperties(_ref91, _excluded91);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M28.76,11.35A1,1,0,0,0,28,11H22V7a3,3,0,0,0-3-3H13a3,3,0,0,0-3,3v4H4a1,1,0,0,0-1,1.15L4.88,24.3a2,2,0,0,0,2,1.7H25.14a2,2,0,0,0,2-1.7L29,12.15A1,1,0,0,0,28.76,11.35ZM12,7a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v4H12ZM25.14,24H6.86L5.17,13H26.83Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShoppingCart = /*#__PURE__*/React.forwardRef(function ShoppingCart(_ref92, ref) {
  var children = _ref92.children,
    _ref92$size = _ref92.size,
    size = _ref92$size === void 0 ? 16 : _ref92$size,
    rest = _objectWithoutProperties(_ref92, _excluded92);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28,7H5.82L5,2.8A1,1,0,0,0,4,2H0V4H3.18L7,23.2A1,1,0,0,0,8,24H26V22H8.82L8,18H26a1,1,0,0,0,1-.78l2-9A1,1,0,0,0,28,7Zm-2.8,9H7.62L6.22,9H26.75Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShoppingCartArrowDown = /*#__PURE__*/React.forwardRef(function ShoppingCartArrowDown(_ref93, ref) {
  var children = _ref93.children,
    _ref93$size = _ref93.size,
    size = _ref93$size === void 0 ? 16 : _ref93$size,
    rest = _objectWithoutProperties(_ref93, _excluded93);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M21.586 6.586L18 10.172 18 2 16 2 16 10.172 12.414 6.586 11 8 17 14 23 8 21.586 6.586z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShoppingCartArrowUp = /*#__PURE__*/React.forwardRef(function ShoppingCartArrowUp(_ref94, ref) {
  var children = _ref94.children,
    _ref94$size = _ref94.size,
    size = _ref94$size === void 0 ? 16 : _ref94$size,
    rest = _objectWithoutProperties(_ref94, _excluded94);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M21.586 9.414L18 5.828 18 14 16 14 16 5.828 12.414 9.414 11 8 17 2 23 8 21.586 9.414z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShoppingCartClear = /*#__PURE__*/React.forwardRef(function ShoppingCartClear(_ref95, ref) {
  var children = _ref95.children,
    _ref95$size = _ref95.size,
    size = _ref95$size === void 0 ? 16 : _ref95$size,
    rest = _objectWithoutProperties(_ref95, _excluded95);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M18.41 8L22 4.41 20.59 3 17 6.59 13.41 3 12 4.41 15.59 8 12 11.59 13.41 13 17 9.41 20.59 13 22 11.59 18.41 8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShoppingCartError = /*#__PURE__*/React.forwardRef(function ShoppingCartError(_ref96, ref) {
  var children = _ref96.children,
    _ref96$size = _ref96.size,
    size = _ref96$size === void 0 ? 16 : _ref96$size,
    rest = _objectWithoutProperties(_ref96, _excluded96);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M17,2a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,17,2Zm0,2a3.9521,3.9521,0,0,1,2.019.5669L13.5669,10.019A3.9529,3.9529,0,0,1,13,8,4.0045,4.0045,0,0,1,17,4Zm0,8a3.9521,3.9521,0,0,1-2.019-.5669L20.4331,5.981A3.9529,3.9529,0,0,1,21,8,4.0045,4.0045,0,0,1,17,12Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShoppingCartMinus = /*#__PURE__*/React.forwardRef(function ShoppingCartMinus(_ref97, ref) {
  var children = _ref97.children,
    _ref97$size = _ref97.size,
    size = _ref97$size === void 0 ? 16 : _ref97$size,
    rest = _objectWithoutProperties(_ref97, _excluded97);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6L12 8 22 8 22 6 12 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShoppingCartPlus = /*#__PURE__*/React.forwardRef(function ShoppingCartPlus(_ref98, ref) {
  var children = _ref98.children,
    _ref98$size = _ref98.size,
    size = _ref98$size === void 0 ? 16 : _ref98$size,
    rest = _objectWithoutProperties(_ref98, _excluded98);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "28",
    r: "2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "2"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9806,2.8039A1,1,0,0,0,4,2H0V4H3.18L7.0194,23.1961A1,1,0,0,0,8,24H26V22H8.82l-.8-4H26a1,1,0,0,0,.9762-.783L29.2445,7H27.1971l-1.9989,9H7.62Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6L18 2 16 2 16 6 12 6 12 8 16 8 16 12 18 12 18 8 22 8 22 6 18 6z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShoppingCatalog = /*#__PURE__*/React.forwardRef(function ShoppingCatalog(_ref99, ref) {
  var children = _ref99.children,
    _ref99$size = _ref99.size,
    size = _ref99$size === void 0 ? 16 : _ref99$size,
    rest = _objectWithoutProperties(_ref99, _excluded99);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H21V28H17zM24 24H28V28H24zM17 17H21V21H17zM24 17H28V21H24z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11h-6V7c0-1.7-1.3-3-3-3h-6c-1.7,0-3,1.3-3,3v4H4c-0.6,0-1,0.4-1,1c0,0.1,0,0.1,0,0.2l1.9,12.1c0.1,1,1,1.7,2,1.7H15v-2 H6.9L5.2,13H28V11z M12,7c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v4h-8V7z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShowDataCards = /*#__PURE__*/React.forwardRef(function ShowDataCards(_ref100, ref) {
  var children = _ref100.children,
    _ref100$size = _ref100.size,
    size = _ref100$size === void 0 ? 16 : _ref100$size,
    rest = _objectWithoutProperties(_ref100, _excluded100);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M28 10H4A2.0022 2.0022 0 012 8V4A2.0021 2.0021 0 014 2H28a2.0021 2.0021 0 012 2V8A2.0022 2.0022 0 0128 10zM4 4V8H28V4zM28 30H4a2.0022 2.0022 0 01-2-2V24a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 30zM4 24v4H28V24zM28 20H4a2.0022 2.0022 0 01-2-2V14a2.0021 2.0021 0 012-2H28a2.0021 2.0021 0 012 2v4A2.0022 2.0022 0 0128 20zM4 14v4H28V14z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShrinkScreen = /*#__PURE__*/React.forwardRef(function ShrinkScreen(_ref101, ref) {
  var children = _ref101.children,
    _ref101$size = _ref101.size,
    size = _ref101$size === void 0 ? 16 : _ref101$size,
    rest = _objectWithoutProperties(_ref101, _excluded101);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28H17a2.0023 2.0023 0 01-2-2V20a2.0023 2.0023 0 012-2H28a2.0027 2.0027 0 012 2v6A2.0027 2.0027 0 0128 28zM17 20v6H28.002L28 20zM12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var ShrinkScreenFilled = /*#__PURE__*/React.forwardRef(function ShrinkScreenFilled(_ref102, ref) {
  var children = _ref102.children,
    _ref102$size = _ref102.size,
    size = _ref102$size === void 0 ? 16 : _ref102$size,
    rest = _objectWithoutProperties(_ref102, _excluded102);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "10",
    x: "15",
    y: "18",
    rx: "2"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10L12 13.586 7.707 9.293 6.293 10.707 10.586 15 7 15 7 17 14 17 14 10 12 10z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M13,22H4a2.0023,2.0023,0,0,1-2-2V7A2.002,2.002,0,0,1,4,5H26a2.0023,2.0023,0,0,1,2,2v9H26V7H4V20h9Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Shuffle = /*#__PURE__*/React.forwardRef(function Shuffle(_ref103, ref) {
  var children = _ref103.children,
    _ref103$size = _ref103.size,
    size = _ref103$size === void 0 ? 16 : _ref103$size,
    rest = _objectWithoutProperties(_ref103, _excluded103);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M22.59,19.41,26.17,23H19.55l-4.37-7,4.37-7h6.62l-3.58,3.59L24,14l6-6L24,2,22.59,3.41,26.17,7H19.55a2,2,0,0,0-1.69.94L14,14.11,10.14,7.94A2,2,0,0,0,8.45,7H2V9H8.45l4.37,7L8.45,23H2v2H8.45a2,2,0,0,0,1.69-.94L14,17.89l3.86,6.17a2,2,0,0,0,1.69.94h6.62l-3.58,3.59L24,30l6-6-6-6Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Shuttle = /*#__PURE__*/React.forwardRef(function Shuttle(_ref104, ref) {
  var children = _ref104.children,
    _ref104$size = _ref104.size,
    size = _ref104$size === void 0 ? 16 : _ref104$size,
    rest = _objectWithoutProperties(_ref104, _excluded104);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM4,8H18v7H4ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V17H28Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SidePanelClose = /*#__PURE__*/React.forwardRef(function SidePanelClose(_ref105, ref) {
  var children = _ref105.children,
    _ref105$size = _ref105.size,
    size = _ref105$size === void 0 ? 16 : _ref105$size,
    rest = _objectWithoutProperties(_ref105, _excluded105);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,15H17.8 l3.6-3.6L20,10l-6,6l6,6l1.4-1.4L17.8,17H28v9H12V6h16V15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SidePanelCloseFilled = /*#__PURE__*/React.forwardRef(function SidePanelCloseFilled(_ref106, ref) {
  var children = _ref106.children,
    _ref106$size = _ref106.size,
    size = _ref106$size === void 0 ? 16 : _ref106$size,
    rest = _objectWithoutProperties(_ref106, _excluded106);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,15H17.8l3.6-3.6L20,10l-6,6l6,6 l1.4-1.4L17.8,17H28v9H12V6h16V15z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SidePanelOpen = /*#__PURE__*/React.forwardRef(function SidePanelOpen(_ref107, ref) {
  var children = _ref107.children,
    _ref107$size = _ref107.size,
    size = _ref107$size === void 0 ? 16 : _ref107$size,
    rest = _objectWithoutProperties(_ref107, _excluded107);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M10,26H4V6h6V26z M28,26H12v-9h10.2 l-3.6,3.6L20,22l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SidePanelOpenFilled = /*#__PURE__*/React.forwardRef(function SidePanelOpenFilled(_ref108, ref) {
  var children = _ref108.children,
    _ref108$size = _ref108.size,
    size = _ref108$size === void 0 ? 16 : _ref108$size,
    rest = _objectWithoutProperties(_ref108, _excluded108);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V6C30,4.9,29.1,4,28,4z M28,26H12v-9h10.2l-3.6,3.6L20,22 l6-6l-6-6l-1.4,1.4l3.6,3.6H12V6h16V26z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Sight = /*#__PURE__*/React.forwardRef(function Sight(_ref109, ref) {
  var children = _ref109.children,
    _ref109$size = _ref109.size,
    size = _ref109$size === void 0 ? 16 : _ref109$size,
    rest = _objectWithoutProperties(_ref109, _excluded109);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H12V14H10zM6 12H8V14H6zM2 12H4V14H2zM26 30H24V27H20a5.0055 5.0055 0 01-5-5V20.7207l-2.3162-.772a1 1 0 01-.5412-1.4631L15 13.7229V11a9.01 9.01 0 019-9h5V4H24a7.0078 7.0078 0 00-7 7v3a.9991.9991 0 01-.1426.5144l-2.3586 3.9312 1.8174.6057A1 1 0 0117 20v2a3.0033 3.0033 0 003 3h5a1 1 0 011 1z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var Sigma = /*#__PURE__*/React.forwardRef(function Sigma(_ref110, ref) {
  var children = _ref110.children,
    _ref110$size = _ref110.size,
    size = _ref110$size === void 0 ? 16 : _ref110$size,
    rest = _objectWithoutProperties(_ref110, _excluded110);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5L7 5 7 7.414 15.586 16 7 24.586 7 27 24 27 24 25 9.414 25 18.414 16 9.414 7 24 7 24 5z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SignalStrength = /*#__PURE__*/React.forwardRef(function SignalStrength(_ref111, ref) {
  var children = _ref111.children,
    _ref111$size = _ref111.size,
    size = _ref111$size === void 0 ? 16 : _ref111$size,
    rest = _objectWithoutProperties(_ref111, _excluded111);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M26 6H28V26H26zM18 11H20V26H18zM11 16H13V26H11zM4 20H6V26H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SimCard = /*#__PURE__*/React.forwardRef(function SimCard(_ref112, ref) {
  var children = _ref112.children,
    _ref112$size = _ref112.size,
    size = _ref112$size === void 0 ? 16 : _ref112$size,
    rest = _objectWithoutProperties(_ref112, _excluded112);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21,9H8a2.0023,2.0023,0,0,0-2,2V21a2.0023,2.0023,0,0,0,2,2H21a2.0023,2.0023,0,0,0,2-2V11A2.0023,2.0023,0,0,0,21,9Zm0,4H18V11h3Zm-3,2h3v2H18Zm-2-4V21H13V14a1,1,0,0,0-1-1H8V11Zm-5,6H8V15h3ZM8,19h3v2H8Zm10,2V19h3v2Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5317,27H4a2.0021,2.0021,0,0,1-2-2V7A2.0021,2.0021,0,0,1,4,5H28a2.0021,2.0021,0,0,1,2,2V19.6379a2.0044,2.0044,0,0,1-.4639,1.2808L25.0679,26.28A1.9944,1.9944,0,0,1,23.5317,27ZM4,7V25H23.5317L28,19.6379V7Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkillLevel = /*#__PURE__*/React.forwardRef(function SkillLevel(_ref113, ref) {
  var children = _ref113.children,
    _ref113$size = _ref113.size,
    size = _ref113$size === void 0 ? 16 : _ref113$size,
    rest = _objectWithoutProperties(_ref113, _excluded113);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8zM4 28H8V20H4z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkillLevelAdvanced = /*#__PURE__*/React.forwardRef(function SkillLevelAdvanced(_ref114, ref) {
  var children = _ref114.children,
    _ref114$size = _ref114.size,
    size = _ref114$size === void 0 ? 16 : _ref114$size,
    rest = _objectWithoutProperties(_ref114, _excluded114);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H22V4h8zM20 30H12V12h8zM10 30H2V18h8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkillLevelBasic = /*#__PURE__*/React.forwardRef(function SkillLevelBasic(_ref115, ref) {
  var children = _ref115.children,
    _ref115$size = _ref115.size,
    size = _ref115$size === void 0 ? 16 : _ref115$size,
    rest = _objectWithoutProperties(_ref115, _excluded115);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zm-6-2h4V14H14zM10 30H2V18h8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkillLevelIntermediate = /*#__PURE__*/React.forwardRef(function SkillLevelIntermediate(_ref116, ref) {
  var children = _ref116.children,
    _ref116$size = _ref116.size,
    size = _ref116$size === void 0 ? 16 : _ref116$size,
    rest = _objectWithoutProperties(_ref116, _excluded116);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H22V4h8zm-6-2h4V6H24zM20 30H12V12h8zM10 30H2V18h8z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkipBack = /*#__PURE__*/React.forwardRef(function SkipBack(_ref117, ref) {
  var children = _ref117.children,
    _ref117$size = _ref117.size,
    size = _ref117$size === void 0 ? 16 : _ref117$size,
    rest = _objectWithoutProperties(_ref117, _excluded117);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M27 28a1 1 0 01-.5-.13l-19-11a1 1 0 010-1.74l19-11a1 1 0 011 0A1 1 0 0128 5V27a1 1 0 01-1 1zM10 16l16 9.27V6.73zM2 4H4V28H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkipBackFilled = /*#__PURE__*/React.forwardRef(function SkipBackFilled(_ref118, ref) {
  var children = _ref118.children,
    _ref118$size = _ref118.size,
    size = _ref118$size === void 0 ? 16 : _ref118$size,
    rest = _objectWithoutProperties(_ref118, _excluded118);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M27 28a.9975.9975 0 01-.501-.1348l-19-11a1 1 0 010-1.73l19-11A1 1 0 0128 5V27a1 1 0 01-1 1zM2 4H4V28H2z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkipBackOutline = /*#__PURE__*/React.forwardRef(function SkipBackOutline(_ref119, ref) {
  var children = _ref119.children,
    _ref119$size = _ref119.size,
    size = _ref119$size === void 0 ? 16 : _ref119$size,
    rest = _objectWithoutProperties(_ref119, _excluded119);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3006V12.7Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V22H9z",
    transform: "rotate(-180 10 16)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkipBackOutlineFilled = /*#__PURE__*/React.forwardRef(function SkipBackOutlineFilled(_ref120, ref) {
  var children = _ref120.children,
    _ref120$size = _ref120.size,
    size = _ref120$size === void 0 ? 16 : _ref120$size,
    rest = _objectWithoutProperties(_ref120, _excluded120);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.301L22 12.699 16.059 16 22 19.301z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Zm-6.9409-6L22,19.3005V12.7Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H10V22H8z",
    transform: "rotate(-180 9 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkipBackOutlineSolid = /*#__PURE__*/React.forwardRef(function SkipBackOutlineSolid(_ref121, ref) {
  var children = _ref121.children,
    _ref121$size = _ref121.size,
    size = _ref121$size === void 0 ? 16 : _ref121$size,
    rest = _objectWithoutProperties(_ref121, _excluded121);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7485l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H11V22H9z",
    transform: "rotate(-180 10 16)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkipBackSolidFilled = /*#__PURE__*/React.forwardRef(function SkipBackSolidFilled(_ref122, ref) {
  var children = _ref122.children,
    _ref122$size = _ref122.size,
    size = _ref122$size === void 0 ? 16 : _ref122$size,
    rest = _objectWithoutProperties(_ref122, _excluded122);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2ZM10,22H8V10h2Zm14-1a1,1,0,0,1-1.4858.874l-9-5a1,1,0,0,1,0-1.748l9-5A1,1,0,0,1,24,11Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23,22a1.0037,1.0037,0,0,1-.4858-.1257l-9-5a1,1,0,0,1,0-1.7486l9-5A1,1,0,0,1,24,11V21a1,1,0,0,1-1,1Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8 10H10V22H8z",
    transform: "rotate(-180 9 16)"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
var SkipForward = /*#__PURE__*/React.forwardRef(function SkipForward(_ref123, ref) {
  var children = _ref123.children,
    _ref123$size = _ref123.size,
    size = _ref123$size === void 0 ? 16 : _ref123$size,
    rest = _objectWithoutProperties(_ref123, _excluded123);
  return /*#__PURE__*/React.createElement(Icon, _objectSpread({
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, rest), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28a1 1 0 01-1-1V5a1 1 0 01.5-.87 1 1 0 011 0l19 11a1 1 0 010 1.74l-19 11A1 1 0 015 28zM6 6.73V25.27L22 16zM28 4H30V28H28z"
  })), children);
});
if (process.env.NODE_ENV !== "production") {}
export { QS, QSAlt, Rss, Rule, RuleCancelled, RuleDataQuality, RuleDraft, RuleFilled, RuleLocked, RulePartial, RuleTest, Ruler, RulerAlt, Run, RunMirror, Running, SailboatCoastal, SailboatOffshore, SalesOps, SankeyDiagram, SankeyDiagramAlt, Sap, Satellite, SatelliteRadar, SatelliteWeather, SatisfyDefinition, SatisfyUsage, Save, SaveModel, Scale, Scales, ScalesTipped, Scalpel, Scan, ScanAlt, ScanDisabled, ScatterMatrix, Schematics, ScisControlTower, ScisTransparentSupply, Scooter, ScooterFront, Screen, ScreenMap, ScreenMapSet, ScreenOff, Script, ScriptReference, Sdk, Search, SearchAdvanced, SearchLocate, SearchLocateMirror, Security, SecurityServices, SelectWindow, Select_01, Select_02, Send, SendActionUsage, SendAlt, SendAltFilled, SendBackward, SendFilled, SendToBack, ServerDns, ServerProxy, ServerTime, ServiceDesk, ServiceId, ServiceLevels, SessionBorderControl, Settings, SettingsAdjust, SettingsCheck, SettingsEdit, SettingsServices, SettingsView, ShapeExcept, ShapeExclude, ShapeIntersect, ShapeJoin, ShapeUnite, Shapes, Share, ShareKnowledge, ShoppingBag, ShoppingCart, ShoppingCartArrowDown, ShoppingCartArrowUp, ShoppingCartClear, ShoppingCartError, ShoppingCartMinus, ShoppingCartPlus, ShoppingCatalog, ShowDataCards, ShrinkScreen, ShrinkScreenFilled, Shuffle, Shuttle, SidePanelClose, SidePanelCloseFilled, SidePanelOpen, SidePanelOpenFilled, Sight, Sigma, SignalStrength, SimCard, SkillLevel, SkillLevelAdvanced, SkillLevelBasic, SkillLevelIntermediate, SkipBack, SkipBackFilled, SkipBackOutline, SkipBackOutlineFilled, SkipBackOutlineSolid, SkipBackSolidFilled, SkipForward, WatsonHealthSaveAnnotation, WatsonHealthSaveImage, WatsonHealthSaveSeries, WatsonHealthScalpelCursor, WatsonHealthScalpelLasso, WatsonHealthScalpelSelect };